/**
 * Helpers de formato. El precio se guarda en MXN; el display en USD es
 * referencial al tipo de cambio del día (C6). Acá el FX es un mock fijo — el
 * backend lo reemplazará por el rate real.
 */
export const MOCK_FX_MXN_PER_USD = 18.5;

export function formatMxn(amount: number, locale: string): string {
  return new Intl.NumberFormat(locale === "en" ? "en-US" : "es-MX", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatUsdApprox(amountMxn: number, locale: string): string {
  const usd = amountMxn / MOCK_FX_MXN_PER_USD;
  return new Intl.NumberFormat(locale === "en" ? "en-US" : "es-MX", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(usd);
}

/** Fecha/hora de reserva: guardada en UTC, se muestra en America/Mazatlan. */
export function formatSessionTime(utcIso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale === "en" ? "en-US" : "es-MX", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "America/Mazatlan",
  }).format(new Date(utcIso));
}
